import { forwardRef } from "react";
import { NwTextField, NwTextFieldProps } from "@nawy/ui";
import { NumericFormat, NumericFormatProps } from "react-number-format";

interface NumericInputProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericInput = forwardRef<NumericFormatProps, NumericInputProps>(
  function NumericInput({ onChange, name, ...other }, ref) {
    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        name={name}
        thousandSeparator
        valueIsNumericString
        allowNegative={false}
        decimalScale={0}
        onValueChange={(values) => {
          onChange({ target: { name, value: values.value } });
        }}
      />
    );
  }
);

interface MoneyFieldProps
  extends Omit<NwTextFieldProps, "type" | "InputProps" | "value" | "onChange"> {
  value: number | string | null | undefined;
  onChange: (value: number | undefined) => void;
  name: string;
}

export const MoneyField = ({
  value,
  onChange,
  name,
  ...rest
}: MoneyFieldProps) => {
  const stringValue =
    value === null || value === undefined || value === ""
      ? ""
      : String(value);

  return (
    <NwTextField
      {...rest}
      name={name}
      value={stringValue}
      onChange={(event) => {
        const next = event.target.value;
        if (next === "") return onChange(undefined);
        // Guard against pathological inputs (paste of "1e10", locale decimals)
        // turning into NaN and being serialized to the wire as null.
        const parsed = Number(next);
        onChange(Number.isFinite(parsed) ? parsed : undefined);
      }}
      InputProps={{
        inputComponent: NumericInput as never,
        endAdornment: (
          <span style={{ color: "var(--mui-palette-text-secondary)", fontSize: 12 }}>
            EGP
          </span>
        ),
      }}
    />
  );
};

export default MoneyField;
